<template>
	<div>
		<ui-alert-errors
			v-if="otherErrorMessages.length > 0"
			:messages="otherErrorMessages"
		/>
		<admin-crop-grid
			:title="title"
			:rows="data"
			:cols="cols"
			:hide-title="true"
			v-bind:row-on-click-handler="rowOnClickHandler"
			defaultOrderBy="id"
			:defaultOrderByAscending="true"
			:show-check-box="true"
		/>
	</div>
</template>

<script>
let options = require("../../cropOptions");
export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		otherErrors: {
			type: Object,
			required: false,
		},
		rowOnClickHandler: {
			type: Function,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			title: this.__("Users"),
			cols: [
				{
					id: "id",
					name: "ID",
					render: (id) => "#" + id,
				},
				{
					id: "company_name",
					name: this.__("Company"),
				},
				{
					id: "address__zip",
					name: this.__("Zip code"),
				},
				{
					id: "offer_count_BUY",
					name: this.__("#BUY"),
					render: (x, row) => row.activity.offers_buy ?? 0,
				},
				{
					id: "offer_count_SELL",
					name: this.__("#SELL"),
					render: (x, row) => row.activity.offers_sell ?? 0,
				},
				{
					id: "thread_count_NEG",
					name: this.__("#NEG"),
					render: (x, row) => row.activity.thread__UNDER_NEGOTIATION ?? 0,
				},
				{
					id: "contract_count",
					name: this.__("#CTR"),
					render: (x, row) => row.activity.contract ?? 0,
				},
				// {
				//     id: "thread_count_CLOSED",
				//     name: this.__("#DEAD"),
				//     render: (x, row) => row.activity.thread__CLOSED ?? 0
				// },
				{
					id: "name",
					name: this.__("Contact person"),
				},
				{
					id: "email",
					name: this.__("E-mail"),
				},
				{
					id: "type",
					name: this.__("Type"),
					render: function (companyType, row) {
						let companyTypeLabel = window.__(
							options.getLabel(companyType, options.companyTypeOptions) ??
								window.__("Others")
						);
						return companyTypeLabel;
					},
					filterOptions: options.companyTypeOptions.map((companyType) => {
						return {
							id: this.__(companyType.name),
							name: this.__(companyType.name),
						};
					}),
				},
				{
					id: "can_paper",
					name: this.__("Paper market"),
					render: (c) => (c ? window.__("Yes") : window.__("No")),
				},
				{
					id: "acl__price_indication",
					name: this.__("Price Ticker"),
					render: (c) => (c ? window.__("Yes") : window.__("No")),
				},
				{
					id: "manager_company_name",
					name: this.__("Boss"),
					render: function (managerCompanyName, row) {
						if (managerCompanyName) {
							return managerCompanyName;
						} else if (row.can_manage) {
							return "Boss";
						} else {
							return "";
						}
					},
				},
				{
					id: "preferred_language",
					name: this.__("Preferred Language"),
				},
				{
					id: "created_at",
					name: this.__("Created"),
					render: (c) => options.formatIsoStamp(c),
				},
			],
		};
	},
	computed: {
		otherErrorMessages() {
			return Object.values(this.otherErrors || {});
		},
	},
};
</script>
